<template>
    <div class="notfound">
        <div class="text">
            404
        </div>
    </div>
</template>

<style lang="less" scoped>
@import '../assets/style/all.less';
.notfound {
    .f();
    .f-d-c();
    .f-cen();
    min-height: 100%;

    .text {
        font-size: 48px;
        color: @brand-color;
        .pingfang-semibold();
    }
}
</style>

<script>
export default {
    name: 'not-found',
};
</script>
